module.exports = new __parcel__URL__("shop_machines_super_swole_squad_department.addb4d7f.png").toString();